import { render } from "./FTSMonthlyPeriodField.vue?vue&type=template&id=83f0348a&ts=true"
import script from "./FTSMonthlyPeriodField.vue?vue&type=script&lang=ts"
export * from "./FTSMonthlyPeriodField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__